import { PageContentWrapper } from '@lmc/ui-kit'
import useHomeType from 'hooks/useHomeType'
import { RotaPatternEditForm } from '../RotaPattern'

export const RotaEditVisitsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContentWrapper
      $gap={12}
      $paddingTop={24}
      $paddingX={48}
      $paddingBottom={24}
    >
      <RotaPatternEditForm type="visit" />
    </PageContentWrapper>
  )
}
